import type { Directorate } from "../../shared/types";
import { SearchableSelect } from "./SearchableSelect";

type Props = {
  directorates: Directorate[];
  selectedId: number | undefined;
  disabled: boolean;
  onSelect: (id: number) => void;
};

const mainDirectorateIds = [8869, 8871];

const ui = {
  directorate: "\u0627\u0644\u0645\u062d\u0627\u0641\u0638\u0629",
  chooseDirectorate: "\u0627\u062e\u062a\u0631 \u0627\u0644\u0645\u062d\u0627\u0641\u0638\u0629",
  searchPlaceholder: "\u0627\u0628\u062d\u062b \u0639\u0646 \u0627\u0644\u0645\u062d\u0627\u0641\u0638\u0629",
  noResults: "\u0644\u0627 \u062a\u0648\u062c\u062f \u0645\u062d\u0627\u0641\u0638\u0629 \u0628\u0647\u0630\u0627 \u0627\u0644\u0627\u0633\u0645.",
  quick: "\u0627\u062e\u062a\u064a\u0627\u0631 \u0633\u0631\u064a\u0639",
};

export const DirectorateField = ({ directorates, selectedId, disabled, onSelect }: Props) => {
  const mainDirectorates = directorates.filter((item) => mainDirectorateIds.includes(item.id));

  return (
    <div className="space-y-3">
      <div>
        <div className="mb-2 flex items-center justify-between gap-3">
          <span className="text-xs font-semibold text-zinc-500">{ui.quick}</span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          {mainDirectorates.map((directorate) => {
            const active = directorate.id === selectedId;
            return (
              <button
                key={directorate.id}
                type="button"
                onClick={() => onSelect(directorate.id)}
                disabled={disabled}
                className={`h-11 rounded-sm border px-3 text-sm font-bold transition focus:outline-none focus:ring-2 focus:ring-teal-300 focus:ring-offset-2 focus:ring-offset-zinc-900 ${
                  active
                    ? "border-teal-400 bg-teal-400 text-zinc-950"
                    : "border-zinc-700 bg-zinc-950 text-zinc-200 hover:border-teal-400 hover:bg-zinc-800"
                } disabled:cursor-not-allowed disabled:opacity-60`}
              >
                {directorate.name}
              </button>
            );
          })}
        </div>
      </div>

      <SearchableSelect
        label={ui.directorate}
        options={directorates}
        selectedId={selectedId}
        disabled={disabled}
        placeholder={ui.chooseDirectorate}
        searchPlaceholder={ui.searchPlaceholder}
        emptyText={ui.noResults}
        onSelect={onSelect}
      />
    </div>
  );
};
